import React from "react";
import {Box, Typography} from "@mui/material";
import {fmtMoneyShort, fmtCompact, fmtPct0, fmtPct, fmtMoneyShort2, fmtDeltaShort, fmtRange, fmtInt, EMPTY, isNilValue} from "./format";
import {TYPE, TABULAR} from "./tokens";

/**
 * The range caption (brief v2.2 §5) — the grid header on desktop, the overview Collapse on phone:
 *
 *   Sep 7–13 · 139 tags · $20,619 (+18% vs Aug 31–Sep 6) · net 84% · 9.0M sent · RPM $2.29 · CTR 5.9%
 *   (no summed coverage: monetized ÷ sent across networks reads 100%+ and misleads — it is a per-tag figure)
 *   · 40 tags = 80% of revenue · 41 earned $0
 *
 * `s` = rollup {fs, mon, clicks, rev, net, rev_prev, coverage, ctr, rpm, rpm_fs, delta_rev_pct}; `count` = rows listed;
 * `cutoffCount` = tags that make 80 % of revenue (null when not computable); `zeroCount` = tags with $0.
 */
export const RangeCaption = ({s, range, days, count, cutoffCount, zeroCount, sx, wrap = false}) => {
    if (!s) return null;
    const netPct = s.rev > 0 ? s.net / s.rev : null;
    const label = range ? fmtRange(range.from, range.to) : EMPTY;
    const prev = range && range.prev_from ? fmtRange(range.prev_from, range.prev_to) : null;
    const delta = fmtDeltaShort(s.delta_rev_pct, s.rev_prev, s.rev);
    const Sep = () => <Box component="span" sx={{mx: 0.5, color: "text.disabled"}}>·</Box>;
    return (
        <Typography component="span" noWrap={!wrap} sx={{...TYPE.caption, fontSize: 12, ...TABULAR, display: "block", minWidth: 0, ...sx}}>
            <Box component="span" sx={{fontWeight: 600, color: "text.primary"}}>{label}</Box>
            {!isNilValue(count) && <><Sep/><Box component="span" sx={{fontWeight: 600, color: "text.primary"}}>{fmtInt(count)} tags</Box></>}
            <Sep/><Box component="span" sx={{fontWeight: 600, color: "text.primary"}}>{fmtMoneyShort(s.rev)}</Box>
            {delta !== EMPTY && <> ({delta}{delta !== "new" && prev ? ` vs ${prev}` : ""})</>}
            {!isNilValue(netPct) && <><Sep/>net {fmtPct0(netPct)}</>}
            <Sep/>{fmtCompact(s.fs)} sent
            <Sep/>RPM {fmtMoneyShort2(s.rpm)}
            <Sep/>CTR {fmtPct(s.ctr)}
            {cutoffCount > 0 && <><Sep/>{cutoffCount} tags = 80% of revenue</>}
            {zeroCount > 0 && <><Sep/>{zeroCount} earned $0</>}
        </Typography>
    );
};

export default RangeCaption;
